import { API } from 'aws-amplify';
import { UpdateUserInput } from 'src/API';
import * as mutations from 'src/graphql/mutations';

export const useUser = () => {
  const updateUser = async (input: UpdateUserInput) => {
    console.log('start updateUser', input);
    try {
      await API.graphql({
        query: mutations.updateUser,
        variables: {
          input,
        },
      });
    } catch (error) {
      console.error('Error updating user:', error);
      throw new Error('ユーザーの更新に失敗しました');
    }
  };
  const recordCybozuCredentials = async (
    userId: string,
    accessToken: string,
    refreshToken: string
  ) => {
    await updateUser({
      id: userId,
      cybozuAccountCredentials: {
        accessToken,
        refreshToken,
      },
    });
  };
  // garoon連携解除
  const cancelGaroonIntegration = async (userId: string) => {
    const input: UpdateUserInput = {
      id: userId,
      cybozuAccountCredentials: null,
    };

    await API.graphql({
      query: mutations.updateUser,
      variables: {
        input,
      },
    });
  };

  return {
    cancelGaroonIntegration,
    recordCybozuCredentials,
  };
};
